<script setup lang="ts">
import type { ProductDocument } from "@/schemas/product-document";

defineProps<{ product: ProductDocument }>();
</script>

<template>
  <div class="">
    <div v-if="product.on_sale" class="text-lg line-through">
      {{ currency(product.regular_price) }}
    </div>
    <div class="text-xl font-medium text-primary">
      {{ currency(product.price) }}
    </div>
  </div>
</template>
